// app/javascript/controllers/clickable_affiliate_row_controller.js

// import { Controller } from "stimulus";
import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  connect() {
    // console.log("Hello from controllers/clickable_affiliate_row_controller.js");
    this.element.addEventListener("click", this.click.bind(this));
  }

  click(event) {
    const target = event.target;


    if (event.target.closest("a, button")) {
      // If it is, allow the default action (e.g., following the link)
      // console.log("target.closest('a, button'): ", target.closest("a, button"));
      return;
    } //else {
      // console.log("elsing........................................");
    //}

    const url = this.element.dataset.url;
    if (url) {
      window.location = url;
    }
  }
}
